import { BaseService } from "services/_baseService";
import appAxios from "services/axios";

class WagonFillAdminService extends BaseService<any> {
  constructor() {
    super(`wagon-fill`);
  }

  // Заполненность по рейсам/поездам. params: { from?, to?, branchID?, trainID? }
  getFill = (params: Record<string, string> = {}) => {
    const qs = new URLSearchParams(
      Object.entries(params).filter(([, v]) => v) as [string, string][],
    ).toString();
    return appAxios.get(`${this.pathWithOrg()}${qs ? `?${qs}` : ""}`);
  };
}

export default new WagonFillAdminService();
